import { formatMoney, formatNumber, CurrencySettings } from 'accounting';
import ordinalModule from 'ordinal';

const commonFormat = {
  neg: '-%s%v',
  pos: '%s%v',
  zero: '-',
};

export function percentage(value: number, emptyValue?: string): string {
  return !value && emptyValue !== undefined ? emptyValue : forceTwoDecimalPoints(value) + '%';
}

export function currencyRounded(value: number): string {
  return formatMoney(value, { precision: 0, format: commonFormat });
}

export function currency(value: number, options?: CurrencySettings<Partial<typeof commonFormat>>): string {
  return formatMoney(value, { format: commonFormat, ...(options || {}) } as CurrencySettings<typeof commonFormat>);
}

export function uptoTwoDecimals(value: number): number {
  return value ? parseInt(String(Math.round(value * 100 + Number.EPSILON)), 10) / 100 : 0;
}

export function toDouble(value: number): number {
  return uptoTwoDecimals(value);
}

export function forceTwoDecimalPoints(value: number): string {
  return formatNumber(value, 2, '');
}

export function isValidCurrencyInput(value: string): boolean {
  return (
    value === '' ||
    value === '0' ||
    /^0[.]\d{0,2}$/.test(value) || // form of 0.54
    /^[1-9]\d*[.]?\d{0,2}$/.test(value)
  ); // form of 43.54 or 1.43 but not 05.54
}

export function ordinal(value: number) {
  return ordinalModule(value);
}

// JavaScript Subtraction is not precise
export function subtract(number1: number, number2: number) {
  return Number((number1 - number2).toFixed(16));
}
